var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-bar-wrap",class:{ dark: _vm.isDark }},[_c('div',{staticClass:"loading-bar"},[_c('div',{ref:"lottieContainer",staticStyle:{"width":"104px","height":"87px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }